import {createHash} from 'crypto';

// In these utilities, we often just look at the last 7 chars to extract the last hashid
const HASHID_LENGTH = 7;

export const getHashFromId = (id?: string) => {
  if (!id) {
    return '';
  }

  return id.slice(-HASHID_LENGTH);
};

export const hashStringSHA256 = (message?: string) => {
  if (!message) {
    return;
  }

  return createHash('sha256').update(message).digest('hex');
};
